export class ConsumerComplaintDocumentModel {
    constructor(data = {}) {
        this.documentId = data.documentId;
        this.complaintId = data.complaintId;
        this.type = data.type;
        this.url = data.url;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
    }
}
